import type { MapMouseEvent } from "maplibre-gl";
import { useMap } from "@/shared/ui/map";
import { useEffect } from "react";

type MapClickHandlerProps = {
  onClick: (lng: number, lat: number) => void;
};

/** Listens for map background clicks (mapcn / MapLibre). */
export function MapClickHandler({ onClick }: MapClickHandlerProps) {
  const { map, isLoaded } = useMap();

  useEffect(() => {
    if (!map || !isLoaded) return;

    const handler = (e: MapMouseEvent) => {
      onClick(e.lngLat.lng, e.lngLat.lat);
    };

    map.on("click", handler);
    return () => {
      map.off("click", handler);
    };
  }, [map, isLoaded, onClick]);

  return null;
}
